"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AcFormField_1 = require("./AcFormField");
exports.AcForm = function (_a) {
    var config = _a.config, fieldMap = _a.fieldMap, mode = _a.mode, onChange = _a.onChange, onBlur = _a.onBlur, showErrors = _a.showErrors;
    var renderFields = function () {
        return Object.keys(config)
            .filter(function (key) {
            if (mode === 'edit') {
                var fieldConfig = config[key];
                return !fieldConfig.readOnly;
            }
            return true;
        })
            .map(function (key) {
            var field = fieldMap[key];
            return (react_1.default.createElement(AcFormField_1.AcFormField, { key: field.fieldName ? field.fieldName : key, fieldName: field.fieldName ? field.fieldName : key, type: field.type, label: field.label, errorId: showErrors ? field.errorId : '', invalid: field.invalid, required: field.required, value: field.value, readOnly: mode === 'view' || field.readOnly, plaintext: mode === 'view' || field.plaintext, onChange: onChange, onBlur: onBlur }));
        });
    };
    return react_1.default.createElement("div", null, renderFields());
};
exports.AcForm.displayName = 'AcForm';
//# sourceMappingURL=AcForm.js.map